import { sendPost } from "../helpers";

const getUsmh = async (params, onResponse) => {
    try {
        const res = await sendPost("/jancode-usmhcode/detail", params);
        if (res.status === 200) {
            if(res.data){
                onResponse(res.data)
            }
        }
    } catch (error) {
        console.log(error);
    }
}

const getAllProducts = async (params, onResponse) => {
    try {
        const res = await sendPost("/category-nutrivalue/getAllProduct", params);
        if (res.status === 200) {
            if(res.data){
                onResponse(res.data)
            }
        }
    } catch (error) {
        console.log(error);
    }
}

const addProducts = async (params, onResponse) => {
    try {
        const res = await sendPost("/products/add", params);
        if (res.status === 200) {
            if(res.data){
                onResponse(res.data)
            }
        }
    } catch (error) {
        console.log(error);
    }
}


const getImgProduct = async (params, onResponse) => {
    try {
        const res = await sendPost("/category-nutrivalue/getProductImg", params);
        if (res.status === 200) {
            if(res.data){
                onResponse(res.data)
            }
        }
    } catch (error) {
        console.log(error);
    }
}

const getHistoryPrd = async (params, onResponse) => {
    try {
        const res = await sendPost("/products/search", params);
        if (res.status === 200) {
            if(res.data){
                onResponse(res.data)
            }
        }
    } catch (error) {
        console.log(error);
    }
}


const updatePrdHistory = async (params, onResponse) => {
    try {
        const res = await sendPost("/products/update", params);
        if (res.status === 200) {
            if(res.data){
                onResponse(res.data)
            }
        }
    } catch (error) {
        console.log(error);
    }
}

const getUsmhDetail = { 
    getUsmh, 
    getAllProducts, 
    addProducts, 
    getImgProduct,
    getHistoryPrd,
    updatePrdHistory
};
export default getUsmhDetail;